import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  loadingDoctorsSelect,
  loadedDoctorsSelect,
  failedDoctorsSelect,
  loadingSummaryProcedures,
  loadedSummaryProcedures,
  failedSummaryProcedures,
  changeParams,
  resetParams,
} from "../../store/secretary/summary_procedure";
import { translations, replaceEmptyToNull } from "../../helpers";

export const useSummaryProcedureStore = () => {
  const dispatch = useDispatch();

  const { doctorsSelect, summaryProcedures, params } = useSelector(
    (state) => state.summaryProcedure
  );

  const getDoctorsBySelect = useCallback(async () => {
    try {
      dispatch(loadingDoctorsSelect());

      const { data } = await gosafeApi.get("doctor/bySelect");

      dispatch(loadedDoctorsSelect(data));
      return;
    } catch (error) {
      dispatch(
        failedDoctorsSelect(
          translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message
        )
      );
      return;
    }
  }, [dispatch]);

  const startGetSummaryProcedures = useCallback(
    async (params) => {
      try {
        dispatch(loadingSummaryProcedures());

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...params,
            startDate: params.startDate
              ? `${params.startDate}T00:00:00.000Z`
              : "",
            endDate: params.endDate ? `${params.endDate}T23:59:59.000Z` : "",
          }).filter(([_, value]) => value !== "")
        );

        // console.log("params", params);
        // console.log("filteredParams", filteredParams);

        const { data } = await gosafeApi.get("summaryProcedures", {
          params: {
            ...filteredParams,
          },
        });

        dispatch(loadedSummaryProcedures(data));
      } catch (error) {
        dispatch(
          failedSummaryProcedures(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch]
  );

  const startSummaryProcedureFilter = useCallback(
    async (params) => {
      try {
        dispatch(changeParams(params));
        const { startDate, endDate } = params;

        if ((startDate && !endDate) || (!startDate && endDate)) {
          throw new Error(
            "Si proporciona una fecha inicial, también debe proporcionar una fecha final, y viceversa."
          );
        }

        if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
          throw new Error(
            "La fecha final no puede ser menor que la fecha inicial."
          );
        }
        await startGetSummaryProcedures(params);
        return;
      } catch (error) {
        dispatch(
          failedSummaryProcedures(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch, startGetSummaryProcedures]
  );

  const startResetParams = useCallback(async () => {
    try {
      dispatch(resetParams());
      await startGetSummaryProcedures({});
      return;
    } catch (error) {
      dispatch(
        failedSummaryProcedures(
          translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message
        )
      );
      return;
    }
  }, [dispatch, startGetSummaryProcedures]);

  const reloadSummaryProcedures = useCallback(async () => {
    await startGetSummaryProcedures(params);
  }, [startGetSummaryProcedures, params]);

  return {
    // Props
    doctorsSelect,
    summaryProcedures,
    params,

    // Methods
    getDoctorsBySelect,
    startGetSummaryProcedures,
    startSummaryProcedureFilter,
    startResetParams,
    reloadSummaryProcedures,
  };
};
